// src/pages/Contact.jsx
import { useState } from "react";
import ViewfinderFrame from "../components/ViewfinderFrame";
import usePageTitle from "../hooks/usePageTitle";
import { SITE, whatsappLink } from "../data/site";
import "./Contact.css";

const ASSUNTOS = [
  "Pacote Aéreo",
  "Pacote Imóvel",
  "Pacote Lançamento",
  "Plano mensal para imobiliária",
  "Conteúdo para redes sociais",
  "Outro",
];

const FORM_VAZIO = { nome: "", email: "", assunto: "", local: "", mensagem: "" };

function Contact() {
  usePageTitle("Contato — D-Rec Produções");

  const [formData, setFormData] = useState(FORM_VAZIO);
  const [status, setStatus] = useState("idle"); // idle | loading | success | error
  const [statusMsg, setStatusMsg] = useState("");

  function handleChange(e) {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setStatus("loading");
    setStatusMsg("Enviando...");

    try {
      const response = await fetch("/api/send", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || "Erro ao enviar. Tente novamente.");
      }

      setStatus("success");
      setStatusMsg("Mensagem enviada com sucesso!");
      setFormData(FORM_VAZIO);
    } catch (err) {
      setStatus("error");
      setStatusMsg(err.message || "Erro ao enviar. Tente novamente.");
    }
  }

  return (
    <section className="contact">
      <div className="section-head">
        <span className="eyebrow">Contato</span>
        <h1 className="section-title">Vamos falar do seu imóvel</h1>
        <p className="contact-intro">
          O jeito mais rápido é o WhatsApp. Se preferir, deixe sua mensagem no formulário e
          respondemos por e-mail.
        </p>
      </div>

      {/* Bloco WhatsApp em destaque */}
      <div className="container">
        <ViewfinderFrame tag="D•REC · WHATSAPP" className="contact-whatsapp">
          <p className="contact-whatsapp-text">Atendimento direto com a equipe, de segunda a sexta em horário comercial.</p>
          <a
            href={whatsappLink()}
            target="_blank"
            rel="noreferrer"
            className="btn btn-primary btn-lg"
          >
            Chamar no WhatsApp
          </a>
          <span className="contact-whatsapp-number">{SITE.whatsappExibicao}</span>
        </ViewfinderFrame>
      </div>

      <div className="contact-layout">
        <form onSubmit={handleSubmit} className="contact-form">
          <label>
            <span>Nome</span>
            <input
              type="text"
              name="nome"
              value={formData.nome}
              onChange={handleChange}
              required
              maxLength={100}
            />
          </label>

          <label>
            <span>E-mail</span>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              maxLength={100}
            />
          </label>

          <label>
            <span>Assunto</span>
            <select name="assunto" value={formData.assunto} onChange={handleChange} required>
              <option value="">Selecione...</option>
              {ASSUNTOS.map((a) => (
                <option key={a} value={a}>
                  {a}
                </option>
              ))}
            </select>
          </label>

          <label>
            <span>Bairro / cidade do imóvel (opcional)</span>
            <input
              type="text"
              name="local"
              value={formData.local}
              onChange={handleChange}
              maxLength={100}
            />
          </label>

          <label>
            <span>Mensagem</span>
            <textarea
              name="mensagem"
              value={formData.mensagem}
              onChange={handleChange}
              rows="5"
              required
              maxLength={5000}
            />
          </label>

          <button type="submit" className="btn btn-primary" disabled={status === "loading"}>
            {status === "loading" ? "Enviando..." : "Enviar mensagem"}
          </button>

          {statusMsg && (
            <p
              className={`contact-status ${
                status === "success" ? "contact-status--success" : ""
              } ${status === "error" ? "contact-status--error" : ""}`}
            >
              {statusMsg}
            </p>
          )}
        </form>

        <aside className="contact-card">
          <span className="contact-card-tag">D•REC · COORDENADAS</span>
          <p>{SITE.endereco}</p>
          <p>
            <span className="contact-card-label">Área de atendimento</span>
            {SITE.areaAtendimento}
          </p>
          <div className="contact-links">
            {SITE.instagramUrl && (
              <a href={SITE.instagramUrl} target="_blank" rel="noreferrer">
                Instagram{SITE.instagramHandle && ` · ${SITE.instagramHandle}`}
              </a>
            )}
            <a href={`mailto:${SITE.email}`}>{SITE.email}</a>
          </div>
        </aside>
      </div>
    </section>
  );
}

export default Contact;
